import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Home, BookOpen, Trophy, Gift, User } from "lucide-react";

const items = [
  { to: "/dashboard", label: "Home", icon: Home, testid: "bottomnav-home" },
  { to: "/library", label: "Library", icon: BookOpen, testid: "bottomnav-library" },
  { to: "/leaderboard", label: "Ranks", icon: Trophy, testid: "bottomnav-leaderboard" },
  { to: "/refer", label: "Refer", icon: Gift, testid: "bottomnav-refer" },
  { to: "/settings", label: "Profile", icon: User, testid: "bottomnav-settings" },
];

export default function BottomNav() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (!user) return null;
  // Hide in lesson player to keep distraction-free
  if (pathname.startsWith("/lesson/")) return null;
  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/85 backdrop-blur-xl border-t border-[var(--line)]"
      style={{ paddingBottom: "max(env(safe-area-inset-bottom), 8px)" }}
      data-testid="mobile-bottom-nav"
    >
      <ul className="grid grid-cols-5 items-stretch">
        {items.map((it) => {
          const active = pathname === it.to || (it.to !== "/dashboard" && pathname.startsWith(it.to));
          const Icon = it.icon;
          return (
            <li key={it.to}>
              <Link
                to={it.to}
                data-testid={it.testid}
                className="flex flex-col items-center justify-center gap-1 py-2.5 transition-colors"
                style={{ color: active ? "var(--primary)" : "var(--ink-3)" }}
              >
                <Icon size={20} strokeWidth={active ? 2.4 : 2} />
                <span className="text-[10px] font-semibold tracking-wide">{it.label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
